import React from "react";
import Wrapper from "../../components/Layout/Wrapper";
import FotoGallery from "../../components/Gallery/FotoGallery";

function GalleryPage() {
    return (
        <>
            <Wrapper color="green">
                <FotoGallery />
            </Wrapper>
        </>
    )
}

export default GalleryPage;